module.exports = __webpack_public_path__ + "img/au.37a54427.svg";